// metodos/InicializarValidarMiembros.js

const getEscarapela = (category) => {
  switch (category) {
    case 'staff': return 'Staff';
    case 'conferencistas': return 'Conferencista';
    case 'asistentes': return 'Asistente';
    default: return '';
  }
};

const getActiveLabels = (camposObligatorios = []) =>
  (camposObligatorios || [])
    .filter(c => c && c.activo && c.label)
    .map(c => c.label);

const ensureFields = (member, labels) => {
  labels.forEach(l => {
    if (!(l in member)) member[l] = '';
  });

  if (member.extras && typeof member.extras === 'object') {
    for (const [k, v] of Object.entries(member.extras)) {
      if (labels.includes(k) && (member[k] == null || String(member[k]).trim() === '')) {
        member[k] = v ?? '';
      }
    }
  }
  return member;
};

export const initializeMembers = (group, category, camposObligatorios = [], options = {}) => {
  const unlimited = !!options.unlimited;
  const memberCount = parseInt(group?.[category] || 0, 10);
  const existingMembers = group.staff_members?.[category] || [];
  const activeLabels = getActiveLabels(camposObligatorios);

  if (unlimited) {
    return existingMembers.map((base) => {
      const member = {
        ...base,
        escarapela: base.escarapela || getEscarapela(category),
        estado: base.estado || '',
        autorizado: base.autorizado ?? '0',
      };
      return ensureFields(member, activeLabels);
    });
  }

  return Array.from({ length: memberCount }, (_, index) => {
    const base = existingMembers[index] ? { ...existingMembers[index] } : {};

    const member = {
      ...base,
      escarapela: base.escarapela || getEscarapela(category),
      estado: base.estado || '',
      autorizado: base.autorizado ?? '0',
    };

    return ensureFields(member, activeLabels);
  });
};

export const fillExistingData = (groupData, camposObligatorios = [], options = {}) => {
  return groupData.map(group => ({
    ...group,
    staff_members: {
      staff: initializeMembers(group, 'staff', camposObligatorios, options),
      conferencistas: initializeMembers(group, 'conferencistas', camposObligatorios, options),
      asistentes: initializeMembers(group, 'asistentes', camposObligatorios, options),
    },
  }));
};
